export function calcularValorAdesao(valor: number | undefined | null, desconto: string | undefined | null): number {
  const v = valor || 0;
  const d = Number(desconto) || 0;
  if (d <= 0) return v;
  if (d >= 100) return 0;
  return v - (v * d) / 100;
}
